/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatsTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ThreatsTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ThreatsTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ThreatsTrendWidgetConfiguration>): ThreatsTrendWidgetConfiguration {
        let obj = Object.assign(new ThreatsTrendWidgetConfiguration(), model);
        ThreatsTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatsTrendWidgetConfiguration>): ThreatsTrendWidgetConfiguration {
        if (!model) return null;
        return ThreatsTrendWidgetConfiguration.newInstance(<ThreatsTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatsTrendWidgetConfiguration) {
        if (!obj) return;

        models.ThreatsTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatsTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatsTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
